import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import contentStyles from "../styles/index.module.css"

class TouristGuide extends React.Component {
  render() {
    return (
      <Layout language="el" location={this.props.location}>
        <SEO title="Tourist Guide" pagePath={this.props.location.pathname} />
        <div className={contentStyles.content}>
          <h1>Τουριστικός Οδηγός</h1>
          <h2>ΒΕΛΙΓΡΑΔΙ</h2>
          <h3>Η πόλη του Βελιγραδίου - Τοποθεσία</h3>
          <p>
            Βελιγράδι (στη σερβική γλώσσα Beograd «Λευκή πόλη») είναι η
            πρωτεύουσα και η μεγαλύτερη πόλη της Σερβίας. Βρίσκεται στη συμβολή
            των ποταμών Σάβου και Δούναβη και στο σταυροδρόμι της πεδιάδας της
            Παννονίας και της Βαλκανικής χερσονήσου. Βρίσκεται στη σύγκλιση
            τριών ιστορικά σημαντικών διαδρομών μεταξύ Ευρώπης και Βαλκανίων:
          </p>
          <ul>
            <li>
              διαδρομή ανατολής-δύσης, κατά μήκος της κοιλάδας του Δούναβη από
              τη Βιέννη προς τη Μαύρη Θάλασσα
            </li>
            <li>
              δυτική διαδρομή, κατά μήκος της κοιλάδας του ποταμού Σάβου προς
              Τεργέστη και βόρεια Ιταλία
            </li>
            <li>
              νοτιοανατολική διαδρομή, κατά μήκος των κοιλάδων των ποταμών
              Μοράβα και Βαρδάρη προς το Αιγαίο Πέλαγος
            </li>
          </ul>
          <p>
            Η αστική περιοχή της πρωτεύουσας έχει πληθυσμό 1,23 εκατομμύρια, ενώ
            πάνω από 1,7 εκατομμύρια άνθρωποι ζουν μέσα στα διοικητικά της όρια.
            Το Βελιγράδι αποτελεί έδρα της κεντρικής κυβέρνησης, των διοικητικών
            οργάνων και των υπουργείων, καθώς και έδρα όλων των μεγαλύτερων
            σερβικών εταιρειών, μέσων ενημέρωσης και επιστημονικών ιδρυμάτων.
          </p>
          <h2>Το Πανεπιστήμιο του Βελιγραδίου</h2>
          <p>
            Το Πανεπιστήμιο του Βελιγραδίου είναι το παλαιότερο και μεγαλύτερο
            Πανεπιστήμιο στη Σερβία και αποτελεί ένα από τα σημαντικότερα
            εκπαιδευτικά και ερευνητικά κέντρα στην Ευρώπη. Ιδρύθηκε το 1808 ως
            το Ανώτατο Εκπαιδευτικό Ίδρυμα του Βελιγραδίου στην επαναστατική
            Σερβία, ενώ το 1838 συγχωνεύτηκε με τα Τμήματα που εδρεύουν στο
            Κραγκούγιεβατς σε ένα ενιαίο Πανεπιστήμιο. Σήμερα, το Πανεπιστήμιο
            του Βελιγραδίου αριθμεί περίπου 97.700 εγγεγραμμένους φοιτητές και
            πάνω από 4.800 ακαδημαϊκά μέλη. Το Πανεπιστήμιο περιλαμβάνει 31
            σχολές, 12 ερευνητικά ινστιτούτα, την Πανεπιστημιακή βιβλιοθήκη και
            9 Πανεπιστημιακά κέντρα. Οι σχολές διακρίνονται σε σχολές Κοινωνικών
            και Ανθρωπιστικών επιστημών, όπως και σε Ιατρικές Επιστήμες, Φυσικές
            Επιστήμες και Μαθηματικά, και Τεχνολογικές Επιστήμες.
          </p>
          <h2>Η Φιλολογική Σχολή</h2>
          <p>
            Η Φιλολογική Σχολή μυεί και μορφώνει τους φοιτητές της στην
            ακαδημαϊκή μελέτη και έρευνα της γλωσσολογίας και της φιλολογίας
            γενικότερα. Από το 1873, συνεχίζει την παράδοση της μόρφωσης των
            νέων που έχουν ολοκληρώσει το Λύκειο με την εισαγωγή τους στη
            τριτοβάθμια εκπαίδευση, αναπτύσσοντας τον φιλολογικό κλάδο.
            Λειτουργεί και εξελίσσεται ως αυτόνομο εκπαιδευτικό ίδρυμα από το
            1960. Σήμερα, η Φιλολογική Σχολή συμπεριλαμβάνει πολλά τμήματα ξένων
            φιλολογιών, τα οποία διαθέτουν τις δικές τους βιβλιοθήκες και στα
            οποία διδάσκονται πάνω από 30 ξένες γλώσσες. Επίσης, διαχειρίζεται
            αρκετά ερευνητικά κέντρα και εκδίδει έναν σημαντικό αριθμό
            επιστημονικών περιοδικών. Η Φιλολογική Σχολή φημίζεται ιδιαίτερα για
            σημαντικές επιστημονικές δημοσιεύσεις και για τη διοργάνωση
            πολιτιστικών εκδηλώσεων.
          </p>
          <hr />
          <p>
            Για περισσότερες πληροφορίες, δείτε τον ακόλουθο ιστότοπο:{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://new.fil.bg.ac.rs/lang/sr/fakultet/o-fakultetu/"
            >
              http://new.fil.bg.ac.rs/lang/sr/fakultet/o-fakultetu/
            </a>
          </p>
        </div>
      </Layout>
    )
  }
}
export default TouristGuide
